import React, { Fragment } from 'react';
import Media from 'react-media';
import SearchBox from '../searchbox';
import {
  ResponsiveFilterWrapper,
  ResponsiveHeaderRow,
  IconClassName,
} from './style';
import FilterIcon from '../../images/filterIcon';
import { ActionButton } from '../buttons';

const ResponsiveFilterContainer = ({ showFilter, children }) => (
  <ResponsiveFilterWrapper id="responsive-filter-wrapper" open={showFilter}>
    {children}
  </ResponsiveFilterWrapper>
);

const ResponsiveTopBar = ({ toggleFilter, searchPlaceholder }) => (
  <Media query="(max-width: 52em)">
    {matches => (
      <Fragment>
        {matches && (
          <Fragment>
            <ResponsiveHeaderRow>
              <ActionButton onClick={toggleFilter}>
                <FilterIcon width={20} height={20} className={IconClassName} />
                Filtern
              </ActionButton>
            </ResponsiveHeaderRow>
            <ResponsiveHeaderRow>
              <SearchBox placeholder={searchPlaceholder} />
            </ResponsiveHeaderRow>
          </Fragment>
        )}
      </Fragment>
    )}
  </Media>
);

export { ResponsiveFilterContainer, ResponsiveTopBar };



// WEBPACK FOOTER //
// ./src/components/filter/responsiveFilter.js